import React from 'react';
import Layout from '../layouts/claire';
import { Link } from 'react-router';
import { preload } from '../../helpers';
import { Animated } from 'react-animated-css';
import config from '../../config';
import Menu from '../partials/menu';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import TopRightMenu from '../partials/top_right_menu';
import fakeAuth from '../../fakeAuth';
import moment from 'moment';
import BlackOverlay from '../partials/black_overlay';
import LineLoader from '../partials/line_loader';
import _ from 'lodash';
import LogEntriesList from './partials/list';

class Logs extends React.Component {
    state = {
        menu_toggled: false,
        start: moment(),
        toggle: 1,
        rooms_selected: [],
        status: config.room_status,
        sort: 'CreationDate',
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null
    }
    // Lifecycle
    componentWillMount() {
        const { id } = this.props.params;
        if (id) {
            this.props.properties_actions && this.props.properties_actions.fetch_logs({ id, date: this.state.start.format('YYYY-MM-DD') });
        }
    }
    componentWillReceiveProps = nextProps => {
        //const { staffs } = nextProps;
        //this.setState({ staffs });
    }
    //  

    renderHeader = () => {
        return <div className="d-flex">
            <div className="w-100 d-flex ">
                <i className="icon-lb_staff blue font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column">
                    <span className="orange ms-3 font-20 line1 poppins">Bitácora</span>
                    <Link to="/properties" className="white ms-3 font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
            </div>
            <div className="w-100">
                <div className="bg-gray-2 black-input d-flex">
                    <i className="fas fa-search font-16 white align-self-center ps-3" />
                    <input className="w-100 p-3 white" type="text" placeholder="Buscar en la Bitácora" ref={(input) => this.txtSearch = input} onChange={e => this.setState({ search: e.target.value })} />
                </div>
            </div>
            <div className="w-100 d-flex align-self-center">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    }

    renderCommon = () => {
        const { id } = this.props.params;
        return (
            <div className="">
                {this.renderHeader()}
                <div className="d-flex justify-content-center my-4">
                    {/* NEXT AND PREV */}
                    <button className="btn bg-gray-dark" onClick={() => {
                        const start = this.state.start.subtract(1, 'days');
                        this.setState({ start });
                        this.props.properties_actions && this.props.properties_actions.fetch_logs({ id, date: start.format('YYYY-MM-DD') });
                    }}>
                        <i className="fas fa-chevron-left white font-12 align-self-center" />
                    </button>
                    {this.state.start && <span className="font-16 white poppins ms-3 align-self-center">{this.state.start.locale('es').format('MMM Do YYYY').toLocaleUpperCase()}</span>}
                    <button className="btn bg-gray-dark ms-3" onClick={() => {
                        const start = this.state.start.add(1, 'days');
                        this.setState({ start });
                        this.props.properties_actions && this.props.properties_actions.fetch_logs({ id, date: start.format('YYYY-MM-DD') });
                    }}>
                        <i className="fas fa-chevron-right white font-12 align-self-center" />
                    </button>
                </div>
                <LogEntriesList {...this.props} search={this.state.search} />
                <div style={{ height: 200 }} />
            </div>
        )
    }
    render() {
        const form = this.props.form_actions;
        const { rooms_selected, status } = this.state;
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>

                    {this.state.microTransac && <LineLoader />}

                    {/* DESKTOP */}
                    <div className="w3-container w3-hide-small " style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>
                    {/* MOBILE */}
                    {/*<div className="w3-container w3-hide-medium w3-hide-large">
                        <div style={{ height: 65 }} />
                        {this.renderCommon()}
        </div>*/}

                    <Menu {...this.state} {...this.props} />

                </section>
            </Layout>
        )
    }
}

export default Logs;
